import { useState } from "react";
import { usePrefs, useT } from "@/context/PreferencesContext";
import { Globe, CurrencyDollar } from "@phosphor-icons/react";

export default function PreferencesModal() {
  const { showPicker, confirmPicker } = usePrefs();
  const [lang, setLang] = useState("fr");
  const [cur, setCur] = useState("cad");
  const t = useT();

  if (!showPicker) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black flex items-center justify-center p-6" data-testid="prefs-modal">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,59,0,0.2),transparent_50%),radial-gradient(circle_at_70%_80%,rgba(255,59,0,0.15),transparent_50%)]" />
      <div className="relative w-full max-w-lg">
        <div className="text-center mb-10">
          <div className="font-display text-6xl md:text-8xl uppercase leading-none">MERCH<span className="text-[#FF3B00]">/</span>HUB</div>
          <div className="mt-4 text-xs uppercase tracking-[0.3em] text-[#FF3B00]">
            {lang === "fr" ? "Bienvenue" : "Welcome"}
          </div>
          <p className="mt-2 text-white/60 text-sm">
            {lang === "fr" ? "Choisissez votre langue et votre devise" : "Choose your language and currency"}
          </p>
        </div>

        <div className="border border-white/20 bg-black/60 backdrop-blur-md p-8 space-y-6">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00] flex items-center gap-2 mb-3">
              <Globe size={14} weight="bold" /> {lang === "fr" ? "Langue" : "Language"}
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[
                { k: "fr", label: "🇫🇷 Français" },
                { k: "en", label: "🇬🇧 English" },
              ].map((o) => (
                <button
                  key={o.k}
                  data-testid={`prefs-lang-${o.k}`}
                  onClick={() => setLang(o.k)}
                  className={`py-4 uppercase tracking-widest text-sm border transition-colors ${lang === o.k ? "bg-[#FF3B00] border-[#FF3B00] text-white" : "border-white/20 text-white/70 hover:border-white"}`}>
                  {o.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00] flex items-center gap-2 mb-3">
              <CurrencyDollar size={14} weight="bold" /> {lang === "fr" ? "Devise" : "Currency"}
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[
                { k: "cad", label: "🇨🇦 CAD" },
                { k: "usd", label: "🇺🇸 USD" },
              ].map((o) => (
                <button
                  key={o.k}
                  data-testid={`prefs-cur-${o.k}`}
                  onClick={() => setCur(o.k)}
                  className={`py-4 uppercase tracking-widest text-sm border transition-colors ${cur === o.k ? "bg-[#FF3B00] border-[#FF3B00] text-white" : "border-white/20 text-white/70 hover:border-white"}`}>
                  {o.label}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={() => confirmPicker(lang, cur)}
            data-testid="prefs-confirm"
            className="w-full py-4 bg-[#FF3B00] text-white uppercase tracking-widest hover:bg-[#E03500]">
            {lang === "fr" ? "Continuer" : "Continue"}
          </button>

          <div className="text-xs text-white/40 text-center">
            {lang === "fr"
              ? "Vous pourrez changer ces préférences à tout moment dans la barre du haut."
              : "You can change these preferences anytime in the top bar."}
          </div>
        </div>
      </div>
    </div>
  );
}
